import OwnerInfo from './OwnerInfo';
import OwnerReview from './OwnerReview';
import { hasProvePrefillConsent } from '../helpers';
import { useApplication } from 'merchant-api/unified';


export const OwnerStep = () => {
  const { applicationData } = useApplication();

  return hasProvePrefillConsent(applicationData ?? undefined)  ? <OwnerReview /> : <OwnerInfo />;
};

export default OwnerStep;
